import { render, staticRenderFns } from "./ImportacaoAceite.vue?vue&type=template&id=4b093496&scoped=true&"
import script from "./ImportacaoAceite.vue?vue&type=script&lang=js&"
export * from "./ImportacaoAceite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b093496",
  null
  
)

export default component.exports